import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ConfirmDialogComponent} from "../../../../../shared/confirm-dialog/confirm-dialog.component";
import {EPushNotificationReminderType} from "../../../../../dto/reminder-type";
import {PushNotificationReminderTypeService} from "../../../../../services/push-notification-reminder-type.service";
import {PushNotificationTemplate} from "../../../../../dto/templates/html-template";
import {PushNotificationReminderType} from "../../../../../dto/push-notification-reminder-type";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-push-notification-reminder-type',
  templateUrl: './push-notification-reminder-type.component.html',
  styleUrls: ['./push-notification-reminder-type.component.css']
})
export class PushNotificationReminderTypeComponent implements OnInit {

  @Input() key: number;
  @Input() reminderType: EPushNotificationReminderType;
  @Input() pushNotificationReminderType: PushNotificationReminderType;
  @Input() pushNotificationReminderTypes: PushNotificationReminderType[];
  @Input() pushNotificationTemplates: PushNotificationTemplate[];






  ReminderType = EPushNotificationReminderType;

  constructor(
    private reminderTypeService: PushNotificationReminderTypeService,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
  ) { }

  configForm: FormGroup;



  ngOnInit() {
    this.initForm(this.pushNotificationReminderType);

  }

  initForm(value: PushNotificationReminderType) {

    this.configForm = this.formBuilder.group({
      id: value.id,
      order:                  [value.order, Validators.required],
      dayOffset:              [value.dayOffset, Validators.required],
      templateId: [value.templateId, Validators.required],

    });
  }

  onSubmit(form: FormGroup) {
    const formValue = form.value;
    formValue.type = this.reminderType;
    if (form.value.id == null) {
      this.reminderTypeService.addReminderType(formValue).subscribe(data => {
        this.pushNotificationReminderType.id = data.id;
        this.initForm(data);
      });
    } else {
      this.reminderTypeService.updateReminderType(formValue).subscribe(data => {
        this.initForm(data);
      });
    }
  }

  delete() {
    this.dialog.open(ConfirmDialogComponent).afterClosed().subscribe(result => {
      if (result == 'ok') {
        if (this.pushNotificationReminderType.id != null) {
          this.reminderTypeService.deleteReminderType(this.pushNotificationReminderType.id).subscribe();
        }
        this.pushNotificationReminderTypes.splice(this.key, 1);
      }
    });
  }


}
